import styled, { css } from 'styled-components';

import { transition } from 'ggApp/utils/mixins';

import Copy from 'ggApp/shared/icons/Copy';
import CheckMark from 'ggApp/shared/icons/CleanTick';

const Button = styled.button`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    ${transition('all', 'medium-mobile', 'standard')};
    &:hover {
        opacity: 0.5;
        cursor: pointer;
    }
    ${({ isActive }) => isActive && css`
        pointer-events: none;
    `};
`;

const ButtonText = styled.h3`
    ${({ theme }) => css(theme.typography.SuperTinyHeadline)};
    cursor: inherit;
    ${({theme}) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        display: none;
    `};
`;

const CopyIcon = styled(Copy)`
    height: 24px;
    width: 24px;
    flex: 0 0 auto;
    margin-right: 4px;
`;

const CheckMarkIcon = styled(CheckMark)`
    margin-right: 4px;
    flex: 0 0 auto;
`;

export {
    Button,
    CopyIcon,
    CheckMarkIcon,
    ButtonText,
};
